import { Label } from "design-system/atoms/Label"
import { cn } from "design-system/utils"
import { ChartBar, Table } from "lucide-react"
import { useTranslation } from "react-i18next"

type Props = {
  value: "chart" | "table"
  onChange: (value: "chart" | "table") => void
}

export function VisualizationSelect({ value, onChange }: Props) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1">
      <Label>{t("segments.visualization.label")}</Label>
      <div className="w-fit inline-flex rounded-md border border-input bg-background overflow-x-auto overflow-y-hidden divide-x divide-input h-10 max-w-full">
        {(["chart", "table"] as const).map((opt) => {
          const isActive = value === opt
          const Icon = opt === "chart" ? ChartBar : Table

          return (
            <button
              key={opt}
              type="button"
              onClick={() => onChange(opt)}
              className={cn(
                "flex flex-row items-center gap-2 px-3 py-1.5 text-sm whitespace-nowrap font-medium",
                "transition-colors focus-visible:outline-hidden focus-visible:ring focus-visible:ring-ring",
                isActive ? "bg-muted" : "text-muted-foreground/80 hover:bg-muted/40",
              )}
            >
              <Icon className="h-4 w-4" />
              <span>{t(`segments.visualization.${opt}`)}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
